module.exports = __webpack_public_path__ + "static/media/iphone_mask.32cf67b8.png";